.tooltip-inner{max-width:600px!important}.tooltip-normal{width:300px!important}
/*# sourceMappingURL=tooltip.component-B5UAKYOS.css.map */
